'use client'

import { useHydrateAtoms } from 'jotai/utils'

import { qrUriAtom } from '../../generatorState'
import { TWifiContent, wifiContentAtom } from './WifiContentState'
import { WifiScreen } from './WifiScreen/WifiScreen'

export const WifiLandingScreen = ({
	uri,
	content,
}: {
	uri: string
	content: TWifiContent
}) => {
	useHydrateAtoms([
		[qrUriAtom, uri],
		[wifiContentAtom, content],
	])

	return <WifiScreen previewMode={false} demoMode={false} />
}
